<i18n>
{
  "fr": {
    "page-title": "Changement d'adresse courriel",
    "message": "Vous avez récemment demandé la modification de l’adresse courriel associée à votre compte sur la plateforme Core. Cliquez sur le bouton pour confirmer le changement.",
    "message2": "Vous serez ensuite déconnecté et redirigé vers la page de connexion. Utilisez votre nouvelle adresse courriel pour vous authentifier.",
    "confirm": "Confirmer",
    "back-to-profile": "Retour",
    "change-user-email-success": "Adresse courriel modifiée avec succès",
    "change-user-email-failure": "Une erreur est survenue",
    "change-user-email-failure-message": "Le changement de courriel n’a pas été effectué. Veuillez réessayer ou contacter votre administrateur."
  },
  "en": {
    "page-title": "Change email address",
    "message": "You recently requested to change the email address associated with your account on the Core platform. Click on the button to confirm the change.",
    "message2": "You will then be signed out and redirected to the login page. Use your new email address to sign in again.",
    "confirm": "Confirm",
    "back-to-profile": "Back",
    "change-user-email-success": "Email address changed successfully",
    "change-user-email-failure": "An error occurred",
    "change-user-email-failure-message": "The email address wasn't changed. Please try again or contact your administrator."
  }
}
</i18n>

<template>
  <welcome>
    <div v-if="!failure">
      <h1 class="title">{{ $t('page-title') }}</h1>
      <p class="content">{{ $t('message') }}</p>
      <p class="content">{{ $t('message2') }}</p>
      <b-button type="is-primary" @click="changeEmailConfirm" :loading="loading">
        {{ $t('confirm') }}
      </b-button>
    </div>
    <div v-else>
      <h1 class="title">{{ $t('change-user-email-failure') }}</h1>
      <p class="content" v-html="$t('change-user-email-failure-message')"></p>
      <b-button type="is-primary" @click="backToProfile">
        {{ $t('back-to-profile') }}
      </b-button>
    </div>
  </welcome>
</template>

<script>
import { URL_ACCOUNT_BUSINESS_SELECT, URL_ACCOUNT_USER_PROFILE } from '@/consts/urls'
import Welcome from '@/components/layout/welcome'
import AuthentificationService from '@/services/authentification'

export default {
  data() {
    return {
      failure: false,
      loading: false,
      token: this.$router.currentRoute.query.token,
      email: this.$router.currentRoute.query.email
    }
  },
  components: {
    Welcome
  },
  computed: {
    currentUserEmail() {
      return this.me ? this.me.email : null
    }
  },
  methods: {
    async changeEmailConfirm() {
      try {
        this.loading = true
        const input = {
          oldEmail: this.currentUserEmail,
          newEmail: this.email,
          token: this.token
        }

        await this.$apollo.mutate({
          mutation: this.$options.mutation.ChangeMyEmailConfirm,
          variables: {
            input
          }
        })

        this.$success(this.$t('change-user-email-success'))
        // Logout
        setTimeout(AuthentificationService.logout, 2000)
      } catch {
        this.failure = true
        this.loading = false
      }
    },
    backToProfile() {
      const returnPath = this.$router.getRoutes().find((x) => x.name === URL_ACCOUNT_USER_PROFILE).path
      // Ensure business selection before going to the profile page
      this.$router.push({
        name: URL_ACCOUNT_BUSINESS_SELECT,
        query: { returnPath }
      })
    }
  },
  apollo: {
    me: {
      query() {
        return this.$options.query.Me
      },
      skip() {
        return !AuthentificationService.getUserIsLogged()
      }
    }
  }
}
</script>

<graphql>
query Me {
  me {
    id
    email
  }
}

mutation ChangeMyEmailConfirm($input: ChangeUserEmailConfirmInput!) {
  changeMyEmailConfirm(input: $input) {
    me {
      id
      email
    }
  }
}
</graphql>
